<template>
    <div class="salesInvoice">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目部：">
                                <el-select v-model="dataForm.projectDeptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="欠款单位：">
                                <el-input v-model="dataForm.debtName" placeholder="请输入欠款单位" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <div v-if="showAdvanceFilter">
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="发票抬头：">
                                    <el-input v-model="dataForm.billHead" placeholder="请输入发票抬头" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="纳税人识别号：">
                                    <el-input v-model="dataForm.billTaxNumber" placeholder="请输入纳税人识别号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="开票申请日期：">
                                    <el-date-picker
                                            v-model="approveTime"
                                            @change="approveTimeChange"
                                            type="daterange"
                                            unlink-panels
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            range-separator="-"
                                            start-placeholder="请选择开始时间"
                                            end-placeholder="请选择结束时间"
                                            :default-time="['00:00:00', '23:59:59']">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="发票录入日期：">
                                    <el-date-picker
                                            v-model="billTime"
                                            @change="billTimeChange"
                                            type="daterange"
                                            unlink-panels
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            range-separator="-"
                                            start-placeholder="请选择开始时间"
                                            end-placeholder="请选择结束时间"
                                            :default-time="['00:00:00', '23:59:59']">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="确认收款日期：">
                                    <el-date-picker
                                            v-model="receiptsTime"
                                            @change="receiptsTimeChange"
                                            type="daterange"
                                            unlink-panels
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            range-separator="-"
                                            start-placeholder="请选择开始时间"
                                            end-placeholder="请选择结束时间"
                                            :default-time="['00:00:00', '23:59:59']">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </div>
                        <el-col :span="showAdvanceFilter? 24 : 6" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportHandle()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="invoiceList"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column
                            prop="projectDeptName"
                            label="项目部"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billHead"
                            label="发票抬头"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="debtName"
                            label="欠款单位"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billTaxNumber"
                            label="纳税人识别号"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="150"
                            prop="notTaxPrice"
                            label="不含税金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="taxPrice"
                            label="税额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="price"
                            label="发票金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billPrice"
                            label="录入发票金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="receiptsPrice"
                            label="收款金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getDeptListService,
        getProjectListService,
        querySumListService,
        sumExportService,
    } from '@/services/invoiceServices'
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "statistics",
        data(){
            return {
                dataForm:{
                    projectDeptId:'',
                    projectId:'',
                    debtName:'',
                    billHead:'',
                    billTaxNumber:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total: 0,
                showAdvanceFilter: false,
                approveTime:[], //申请日期
                billTime:[],    //录入日期
                receiptsTime:[],//确认收款日期

                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[],
                btnAuthorize: {
                    export: { key: "export", btnEnable: false }
                },
            }
        },
        props: {
            menuCode: {
                type: String
            }
        },
        methods:{
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getInvoiceList();
                this.getDeptList();
            },
            query(){
                this.getInvoiceList();
            },
            reset(){
                this.dataForm = {
                    projectDeptId:'',
                    projectId:'',
                    debtName:'',
                    billHead:'',
                    billTaxNumber:'',
                    pageIndex: 1,
                    pageSize: 10,
                }
                this.approveTime= []
                this.billTime= []
                this.receiptsTime= []
                this.getInvoiceList();
            },
            // 获取数据
            getInvoiceList(){
                let paramsData = {
                    ...this.dataForm
                }
                querySumListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.invoiceList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.projectDeptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            moreScreen() {
                this.showAdvanceFilter = !this.showAdvanceFilter;
                // if (this.showAdvanceFilter) {
                //     this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
                // } else {
                //     this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
                // }
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
            /**
             * 导出
             * */
            exportHandle(){
                if(this.receiptsTime){

                }
                let params = {
                    ...this.dataForm,
                    pageSize: 10000,
                }
                sumExportService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            dblclickDetail(row, column, cell, event) {
                console.log(row)
                this.bus.$emit("navMenuChange", {
                    routeId: "salesInvoiceDetail",
                    routeParam: {
                        approveId: row.approveId
                    }
                });
            },
            approveTimeChange(val){
                if(val){
                    this.dataForm.approveStartTime = this.approveTime[0];
                    this.dataForm.approveEndTime = this.approveTime[1];
                }else{
                    this.dataForm.approveStartTime = '';
                    this.dataForm.approveEndTime = '';
                }
            },
            billTimeChange(val){
                if(val){
                    this.dataForm.billStartTime = this.billTime[0];
                    this.dataForm.billEndTime = this.billTime[1];
                }else{
                    this.dataForm.billStartTime = '';
                    this.dataForm.billEndTime = '';
                }
            },
            receiptsTimeChange(val){
                if(val){
                    this.dataForm.receiptsStartTime = this.receiptsTime[0];
                    this.dataForm.receiptsEndTime = this.receiptsTime[1];
                }else{
                    this.dataForm.receiptsStartTime = '';
                    this.dataForm.receiptsEndTime = '';
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .salesInvoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
    }
</style>

